export const isPresent = (v) => v && v !== '';
export const hasWhiteSpace = (v) => /\s/.test(v);
export const isNumber = (value) => {
    return typeof value === 'number' && !Number.isNaN(value);
};
export const isPositiveIntegerOrZero = (value) => {
    return isNumber(value) && Number.isInteger(value) && value >= 0;
};
export const isValidPassword = (p) => isPresent(p) && !hasWhiteSpace(p) && p.length >= 6;
export const isEmail = (email) => {
    const reg = 
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test((email || '').toLowerCase());
};
export const isValidLatitude = (lat) => {
    const reg = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,7})?))$/;
    return reg.test(lat.toString());
};
export const isValidLongitude = (long) => {
    const reg = /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,7})?))$/;
    return reg.test(long.toString());
};
export const isValidTime = (time) => {
    const reg = new RegExp('^([0-1]?[0-9]|[2][0-3]):([0-5][0-9])(:[0-5][0-9])?$');
    return reg.test(time);
};
export const isValidTimeCombination = (beginTime, endTime) => {
    const begin = beginTime.replace(':', '');
    const end = endTime.replace(':', '');
    return end > begin;
};
export const isWorldTime = (time) => {
    const reg = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;
    return reg.test(time.toString());
};
export const isUsTime = (time) => {
    const reg = /^(0?[1-9]|1[0-2]):([0-5]\d)\s?(?:AM|PM)$/i;
    return reg.test(time.toString());
};
export const atMostOneDecimalRegex = new RegExp('^-?([0-9]+.?[0-9]?)?$');
export const isAtMostOneDecimal = (num) => {
    return atMostOneDecimalRegex.test(num.toString());
};
export const isValidISODateString = (dateString) => {
    //checks if date strings are in correct YYYY-MM-DD format
    const reg = new RegExp(/^(19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/g);
    return reg.test(dateString);
};
export const isFromDateBeforeToDate = (fromDate, toDate) => {
    const fromDateUnix = Date.parse(fromDate);
    const toDateUnix = Date.parse(toDate);
    return fromDateUnix < toDateUnix;
};
